import Vue from 'vue';
import 'intersection-observer';

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 1.0,
};

const exposureList: string[] = [];
Vue.directive('exposure', {
  bind(el, binding) {
    const data = binding.value;
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (exposureList.includes(data.id)) {
            return;
          }
          data.callback();
          exposureList.push(data.id);
        }
      });
    }, options).observe(el);
  },
});
